/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Pain_Item41Inputs */

const ja_playdata_eventreport_pain_item41 = /** @type {(inputs: Playdata_Eventreport_Pain_Item41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配信プラットフォームごとの視聴者数の違いを知りたい`)
};

const en_playdata_eventreport_pain_item41 = /** @type {(inputs: Playdata_Eventreport_Pain_Item41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to know how viewer numbers differ by streaming platform`)
};

/**
* | output |
* | --- |
* | "I want to know how viewer numbers differ by streaming platform" |
*
* @param {Playdata_Eventreport_Pain_Item41Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_pain_item41 = /** @type {((inputs?: Playdata_Eventreport_Pain_Item41Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Pain_Item41Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_pain_item41(inputs)
	return en_playdata_eventreport_pain_item41(inputs)
});
export { playdata_eventreport_pain_item41 as "playdata_eventReport_pain_item4" }